define.alias("shared/utils/time-slot-utils", "media/utils/time-slot-utils");